import Phaser from 'phaser';
import { installNotices, platform } from '@platoon/client-kit';
import { BootScene } from './BootScene';
import { GameScene } from './GameScene';
import { HudScene, OPEN_MENU, UI_NOTICE } from './HudScene';
import { installLobby } from './lobby';

const game = new Phaser.Game({
  type: Phaser.AUTO,
  parent: 'game',
  width: window.innerWidth,
  height: window.innerHeight,
  pixelArt: false,
  backgroundColor: '#0b0f0c',
  scale: {
    mode: Phaser.Scale.RESIZE,
    autoCenter: Phaser.Scale.CENTER_BOTH,
  },
  scene: [BootScene, GameScene, HudScene],
});

// Dev builds expose the game for console poking and automated checks.
if (import.meta.env.DEV) (window as unknown as { __mayday: Phaser.Game }).__mayday = game;

// ---- Notices and the menu (plain DOM over the canvas; docs/screens/menu.md) --
installNotices(game, document.getElementById('notice')!, UI_NOTICE);

const lobby = installLobby({
  game,
  root: document.getElementById('lobby')!,
  isTouch: platform.isTouchPrimary(),
  isBoardPinned: () => game.registry.get('boardPinned') === true,
});
game.events.on(OPEN_MENU, () => lobby.open());
